<template>
	<nav class="navbar navbar-expand-lg navbar-light ms-auto p-0 m-0">
		<div class="container-fluid p-0 m-0">
			<div class="collapse navbar-collapse" id="navbarUser">
				<ul class="navbar-nav me-auto mb-2 mb-lg-0">
					<li class="nav-item dropdown animatedmenu" :class="{ 'text-white' : main.isavailable }">
						<a class="nav-link dropdown-toggle p-0 m-0" href="#" id="navbarDropdownExplore" role="button" data-bs-toggle="dropdown" aria-expanded="false">
							<BAvatar v-if="!avatar" rounded="circle"><i class="bi bi-person-fill"></i></BAvatar>
							<BAvatar v-if="avatar" rounded="circle" :src="avatar" />
						</a>
						<ul :class="{ 'homepage-user-menu' : main.isavailable }" @click="umenu.refresh=!umenu.refresh" class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownExplore">
							<!-- <li v-if="!school">
								<router-link @click="$scrollToTop" to="/u/my/gamedashboard" aria-current="page" class="dropdown-item tt-dropdown-item">Game Dashboard</router-link>
							</li> -->
							<li v-if="iscompany">
								<router-link @click="$scrollToTop" to="/u/my/company" aria-current="page" class="dropdown-item tt-dropdown-item">{{ $t('menu.mycompany', 'My Company') }}</router-link>
							</li>
							<li v-if="isteacher">
								<router-link @click="$scrollToTop" to="/u/tr/dashboard" aria-current="page" class="dropdown-item tt-dropdown-item">{{ $t('menu.teacherdashboard', 'Teacher Dashboard') }}</router-link>
							</li>
							<li v-if="!iscompany">
								<router-link @click="utab.selectedtab = 'dashboard';$scrollToTop" to="/u/my/dashboard" aria-current="page" class="dropdown-item tt-dropdown-item">{{ $t('menu.mydashboard', 'My Dashboard') }}</router-link>
							</li>
							<li v-if="!school">
								<router-link @click="$scrollToTop" to="/u/my/account" aria-current="page" class="dropdown-item tt-dropdown-item">{{ $t('menu.myaccount', 'My Account') }}</router-link>
							</li>
							<li>
								<hr class="dropdown-divider">
							</li>
							<li>
								<a role='button' @click="logOut" class="dropdown-item tt-dropdown-item">{{ $t('menu.signout', 'Log Out') }}</a>
							</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	</nav>
</template>
<script lang="ts" setup>
import { nextTick, watch, ref } from 'vue'
import axios from 'axios';
import { userMenuStore } from '@/store/userMenuStore';
import { BAvatar } from 'bootstrap-vue-next';
import { generateRandomAlphaNum, cleanUser } from "@/common/common.js";
import { userMainStore } from '@/store/userMainStore';
import { userAvatarStore } from '@/store/userAvatarStore';
import { userTabStore } from '@/store/userTabStore';

const main = userMainStore();
const avatarstore = userAvatarStore();
// const emit = defineEmits(['refreshMenu']);
const umenu = userMenuStore();
const utab = userTabStore();

let token = localStorage.getItem("token");
let avatar = ref(localStorage.getItem("avatar"));
let school = localStorage.getItem("school");
let iscompany = localStorage.getItem("iscompany");
// let isstudent = localStorage.getItem("isstudent");
let isteacher = localStorage.getItem("isteacher");
// let username = getCookie("uname");
// console.log("username", username);

watch(() => umenu.refreshtop, () => {
	let slm = umenu.selectedmenu;
	let navbarUser = document.querySelectorAll('#navbarUser >ul  ul.dropdown-menu li > a.dropdown-item');
	navbarUser.forEach((item) => {
		item.classList.remove("router-link-active");
		item.classList.remove("router-link-exact-active");
		if (item.getAttribute('href')?.endsWith(slm)) {
			item.classList.add("router-link-active");
			item.classList.add("router-link-exact-active");
		}
	})
});

watch(() => avatarstore.refresh, async() => {
	avatar.value = null;
	await nextTick
	avatar.value = localStorage.getItem("avatar");
});

const logOut = async () => {
	await axios
		.get('/api/v1/logout', {
			headers: { Authorization: `${token}` },
			withCredentials: true
		})
		.then(() => {
			cleanUser();
			document.location = "/login?" + generateRandomAlphaNum(5);
		});
}


// function getCookie(id: unknown) {
// 	const value = document.cookie.match('(^|;)?' + id + '=([^;]*)(;|$)');
// 	// console.log("ocument.cookie", document.cookie);
// 	return value ? unescape(value[2]) : null;

// }
</script>
<style scoped lang="scss">
#app nav>.nav-link {
	font-weight: 600;
	border-radius: 0;
	border-bottom: 1px solid transparent;
}

nav .dropdown-item {
	margin: 6px auto;
}

.dropdown-item {
	color: var(--Off-black-100, #161616);
	font-family: Roboto;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
	letter-spacing: 0.5px;
}

#app nav a.router-link-active.router-link-exact-active.nav-link,
#app nav .nav-link.dropdown-toggle.show {
	border-radius: 0;
}

#app .nav-link.dropdown-toggle.show {
	xbackground-color: var(--tt-1);
}


#app .nav-link:hover {
	border-bottom: 1px solid var(--tt-1) !important;
}

#app nav .dropdown-menu a:hover {
	border-bottom: none !important;
}

.dropdown-menu {
	--bs-dropdown-border-color: #f1f1f1;
	padding: 30px;
	min-width: 300px;
}

.dropdown-menu {
	border-radius: 8px;
	background: var(--Background-White, #FFFFFE);
	box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 1px 3px 1px rgba(0, 0, 0, 0.15);
}

.nav-item.dropdown .dropdown-item {
	x-color: var(--tt-1);
}

.dropdown-item:hover,
.dropdown-item:focus {
	color: rgba(var(--tt-1-rgb), 1);
	background-color: transparent;
}

/*
nav .dropdown-menu a.router-link-exact-active:hover {
	background-color: #000;
}
*/

.dropdown-toggle::after {
	color: #161616;
}

.dropdown-toggle {
	padding-left: 16px!important;
}

nav .dropdown-menu a.router-link-exact-active {
	color: var(--x-link-active-color);
	background-color: var(--tt-11);
	background-image: var(--gradient-dark) !important;
	border-radius: 5px;
}

#app .nav-link {
	border-bottom: 1px solid transparent;
	border-left: 1px solid transparent;
	border-right: 1px solid transparent;
}
</style>